import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddressType, ThreadMemberScope, useDialectSdk, useNotificationChannel, useNotificationChannelDappSubscription, useThread, useThreads, } from '@dialectlabs/react-sdk';
import clsx from 'clsx';
import { useCallback } from 'react';
import { shortenAddress } from '../../../../utils/displayUtils';
import { Button, Loader, Toggle } from '../../../common';
import { P } from '../../../common/preflighted';
import { useTheme } from '../../../common/providers/DialectThemeProvider';
import IconButton from '../../../IconButton';
const ADDRESS_TYPE = AddressType.Wallet;
const Wallet = ({ dappAddress, onThreadDeleted, onThreadCreated, showLabel = true, }) => {
    const { wallet: { address: walletAddress }, } = useDialectSdk();
    const { textStyles, outlinedInput, adornmentButton, icons, colors } = useTheme();
    const { create: createThread, isCreatingThread } = useThreads();
    const { globalAddress: walletSubscriptionAddress, create: createAddress, delete: deleteAddress, isCreatingAddress, isDeletingAddress, } = useNotificationChannel({ addressType: ADDRESS_TYPE });
    const { enabled: subscriptionEnabled, toggleSubscription, isToggling, } = useNotificationChannelDappSubscription({
        addressType: ADDRESS_TYPE,
        dappAddress,
    });
    const { thread, delete: deleteDialect, isDeletingThread, } = useThread({
        findParams: { otherMembers: dappAddress ? [dappAddress] : [] },
    });
    const deleteThread = useCallback(async () => {
        await deleteDialect();
        await deleteAddress();
        onThreadDeleted === null || onThreadDeleted === void 0 ? void 0 : onThreadDeleted();
    }, [deleteAddress, deleteDialect, onThreadDeleted]);
    const createWalletThread = useCallback(async () => {
        if (!dappAddress)
            return;
        return createThread({
            me: { scopes: [ThreadMemberScope.ADMIN] },
            otherMembers: [
                { address: dappAddress, scopes: [ThreadMemberScope.WRITE] },
            ],
            encrypted: false,
        });
    }, [createThread, dappAddress]);
    const createWalletAddress = useCallback(() => createAddress({ value: walletAddress }), [createAddress, walletAddress]);
    const fullEnableWallet = useCallback(async () => {
        const address = await createWalletAddress();
        const thread = await createWalletThread();
        if (!thread) {
            return;
        }
        await toggleSubscription({ enabled: true, address });
        onThreadCreated === null || onThreadCreated === void 0 ? void 0 : onThreadCreated(thread);
    }, [
        createWalletAddress,
        createWalletThread,
        onThreadCreated,
        toggleSubscription,
    ]);
    const isLoading = isDeletingThread ||
        isCreatingThread ||
        isDeletingAddress ||
        isCreatingAddress ||
        isToggling;
    const walletEnabled = thread && walletSubscriptionAddress;
    return (_jsxs("div", { children: [showLabel && (_jsx("label", { htmlFor: "settings-email", className: clsx(colors.label, textStyles.label, 'dt-block dt-mb-1'), children: "Wallet" })), _jsx("div", { className: clsx('dt-flex dt-items-center dt-border !dt-bg-transparent', outlinedInput), children: _jsx("div", { className: clsx('dt-w-full dt-bg-transparent dt-outline-0', textStyles.input), children: _jsxs("div", { className: "dt-flex dt-justify-between dt-items-center", children: [_jsx("span", { className: 'dt-opacity-40', children: shortenAddress(walletAddress || '') }), walletEnabled && !isLoading && (_jsx(IconButton, { className: clsx(adornmentButton, 'dt-w-9 dt-h-9'), icon: _jsx(icons.trash, {}), onClick: deleteThread })), !thread && !walletSubscriptionAddress && !isLoading && (_jsx(Button, { onClick: fullEnableWallet, className: clsx(adornmentButton, 'dt-w-16 dt-h-9'), children: "Enable" })), walletSubscriptionAddress && !thread && !isLoading && (_jsx(Button, { onClick: createWalletThread, className: clsx(adornmentButton, 'dt-w-16 dt-h-9'), children: "Enable" })), thread && !walletSubscriptionAddress && !isLoading && (_jsx(Button, { onClick: createWalletAddress, className: clsx(adornmentButton, 'dt-w-16 dt-h-9'), children: "Enable" })), isLoading && (_jsx("div", { className: clsx('dt-h-9 dt-w-9 dt-rounded-full dt-flex dt-items-center dt-justify-center dt-text-xs dt-border-0 dt-opactity-60', colors.textPrimary), children: _jsx(Loader, {}) }))] }) }) }), walletEnabled && (_jsxs("div", { className: "dt-flex dt-flex-row dt-space-x-2 dt-items-center dt-mt-1", children: [_jsx(Toggle, { type: "checkbox", checked: subscriptionEnabled, toggleSize: "S", onChange: (checked) => {
                            if (isToggling)
                                return;
                            return toggleSubscription({ enabled: checked });
                        } }), _jsxs(P, { className: clsx(textStyles.small, 'dt-opacity-60'), children: ["Notifications ", subscriptionEnabled ? 'on' : 'off'] })] }))] }));
};
export default Wallet;
//# sourceMappingURL=Wallet.js.map